import paginationFactory from "react-bootstrap-table2-paginator";
import React from 'react';
import { AUTHORITIES } from '../config/constants';

export const hasAnyAuthority = (authorities: string[], hasAnyAuthorities: string[]) => {
    if (authorities && authorities.length !== 0) {
        if (hasAnyAuthorities.length === 0) {
        return true;
        }
        return hasAnyAuthorities.some(auth => authorities.includes(auth));
    }
    return false;
};

export const isFreeUser = (authorities: string[]) => {
  let result = true;
  if (authorities && authorities.length !== 0) {
    authorities.map(role => {
      if (role === 'ROLE_ADMIN' || role === 'ROLE_SUBSCRIPTION_USER') {
        result = false;
      }
    });
  }
  return result;
};

export const limitContent = (authorities: string[], data, length) => {
  let result = true;
  if (authorities && authorities.length !== 0) {
    authorities.map(role => {
      if (role === 'ROLE_ADMIN' || role === 'ROLE_SUBSCRIPTION_USER') {
        result = false;
      }
    });
  }

  if (result) {
    return data.slice(0, length);
  }
  return data;
};

export const truncateText = (text, length) => {
    if (text && text.length > length) {
        text = text.substring(0, length - 3) + "...";
    }
    return text;
}

export const pagination = paginationFactory({
    page: 1,
    alwaysShowAllBtns: true,
    showTotal: true,
    withFirstAndLast: false,
    sizePerPageRenderer: ({ options, currSizePerPage, onSizePerPageChange }) => (
      <div className="dataTables_length" id="datatable-basic_length">
        <label>
          Show{" "}
          {
            <select
              name="datatable-basic_length"
              aria-controls="datatable-basic"
              className="form-control form-control-sm"
              onChange={e => onSizePerPageChange(e.target.value)}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          }{" "}
          entries.
        </label>
      </div>
    )
  });